import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["label"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { Loader, StyledLoaderSpinner } from "../../loader";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledSpinner = styled(StyledLoaderSpinner)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var StyledButtonLoader = styled(Loader)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", " {\n    z-index: ", ";\n  }\n"])), StyledSpinner, function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.buttonContent.value;
});

var ButtonLoader = function ButtonLoader(_ref2) {
  var label = _ref2.label,
      other = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(StyledButtonLoader, _objectSpread({
    hideLabel: true,
    label: label
  }, other));
};

ButtonLoader.displayName = "ButtonLoader";
ButtonLoader.propTypes = {
  /** Text that is read for screen reader users */
  label: PropTypes.node
};
ButtonLoader.defaultProps = {
  label: 'Loading...'
};
export { ButtonLoader, StyledButtonLoader };